import React, { useState, Fragment, useEffect } from "react";
import Item from "../Item/Item";
import Modal from "../Modal/Modal";
import OrdersModal from "../OrdersModal/OrdersModal";
import LoadingComponet from "../../Components/LoadingComponet/LoadingComponet";
import Style from "../OrderDelivered/OrderDelivered.module.css";
import { getCurrentPeykApi, getDeliveringOrdersApi } from "../../Api/DeliveryBarest";
import { errorToast } from "../../Utils/Toast/Toast";
import CurrentPeykAccepted from "../CurrentPeykAccepted/CurrentPeykAccepted";

const OrderOnDelivery = () => {
  const [purchased, setPurchased] = useState(false);
  const [productData, setProductData] = useState();
  const [peykDataState, setPeykDataState] = useState([]);
  const [data, setData] = useState();
  /////get delivering orders ///

  useEffect(() => {
    getDeliveringOrders();
  }, []);


  const getDeliveringOrders = async () => {
    getDeliveringOrdersApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setData(res.orders)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    });
    getCurrentPeykApi((succ,res)=>{
          if(succ){
            if(res.status===0){
              errorToast(res.message)
            }else{
              let sorted = [...res.requests].sort((a, b) => {
                return a.id > b.id ? -1 : 1;
              });
              setPeykDataState(sorted);
            }
          }else{
            console.error(res)
          }
        });
    // if(localStorage.getItem("deliveryToken")){
    //     if(result.status===-2){
    //         localStorage.clear()
    //         logout()
    //         history.push("/login")
    //         setTimeout(() => {
    //             window.location.reload()
    //         }, 100);
    //     }
    // }
  };
  /////closing modal of order list/////
  const closeList = () => {
    setPurchased(false);
  };
  /////get products of a order  from child/////
  const handleCallback = (childData) => {
    setProductData(childData);
  };

  let loading = null;
  if (data === undefined) {
    loading = <LoadingComponet />;
  } else {
    loading = (
      <div className={Style.pageHolder}>
        <Modal
          show={purchased}
          modalClose={() => setPurchased(false)}
          translate={40}
        >
          <OrdersModal setShow={closeList} data={productData} />
        </Modal>
        <div className={Style.itemHolder}>
          <Item
            setPurchased={setPurchased}
            btnAccept={false}
            data={data}
            time={true}
            orderlist={true}
            address={true}
            deliver={true}
            parentCallback={handleCallback}
            peykData={peykDataState}
          />
          {
             peykDataState?.map(item=>{
            return(
              <CurrentPeykAccepted key={item.id} data={item} UpdateReq={getDeliveringOrders}/>
            )
          })
          }
        </div>
      </div>
    );
  }
  return <Fragment>{loading}</Fragment>;
};
export default OrderOnDelivery;
